import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: any) => ({
	cardContent: {
		padding: 0
	},
	action: {
		height: "100%",
		margin: 0,
		alignSelf: "unset"
	}
}));

export default useStyles;
